unit UAbwForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UStampModel,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig, Types,
  Vcl.Grids, WEBLib.Grids, WEBLib.Buttons, UFeiertagList, UTagKzList;

type
  TAbwForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlButton: TPanel;
    btnHoliday: TBitBtn;
    pnlData: TPanel;
    sgAbw: TStringGrid;
    btnPrior: TBitBtn;
    btnNext: TBitBtn;
    pnlAbw: TPanel;
    sgAbwLegend: TStringGrid;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnPriorClick(Sender: TObject);
    procedure btnNextClick(Sender: TObject);
    procedure sgAbwClickCell(Sender: TObject; ACol, ARow: Integer);
    [Async]
    procedure btnHolidayClick(Sender: TObject); async;
  private
    yearMin: Integer;
    yearMax: Integer;
    FMainConfig: TMainConfig;
    FYear: Integer;
    FFeiertagList: TFeiertagList;
    FTagKzList: TTagKzList;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    procedure GetFeiertage;
    procedure GetLastFakStamp;
    procedure GetStatus;
    procedure GetTagKz;
    procedure GetAbw;
    procedure SgAbwInit;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetYear(Value: Integer);
    procedure SetFeiertagList(const Value: TFeiertagList);
    procedure SetTagKzList(const Value: TTagKzList);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Year: Integer read FYear write SetYear;
    property FeiertagList: TFeiertagList read FFeiertagList
      write SetFeiertagList;
    property TagKzList: TTagKzList read FTagKzList write SetTagKzList;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  AbwForm: TAbwForm;

implementation

uses
  UEssentialHelper, UGridHelper, System.DateUtils, Math, UAbwHelper,
  UFeiertagModel, UTagKzModel, UHolidayNewForm;

{$R *.dfm}
{ TAbwForm }

procedure TAbwForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TAbwForm.btnHolidayClick(Sender: TObject);
var
  frm: THolidayNewForm;
begin
  Self.MainConfig.TimerReset;
  frm := THolidayNewForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(THolidayNewForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
    Self.GetFeiertage;
  end;
end;

procedure TAbwForm.btnNextClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Year := Self.Year + 1;
end;

procedure TAbwForm.btnPriorClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Year := Self.Year - 1;
end;

procedure TAbwForm.GetAbw;
var
  lst: TStringList;
  i, cc: Integer;
  model: TTagKzModel;
begin
  cc := -1;
  sgAbwLegend.ColCount := 1;
  sgAbwLegend.RowCount := 1;
  sgAbwLegend.FixedCols := 0;
  sgAbwLegend.FixedRows := 0;
  sgAbwLegend.Cells[0, 0] := '';
  if Self.TagKzList <> nil then
  begin
    lst := TStringList.Create;
    for i := 0 to Self.TagKzList.Count - 1 do
    begin
      if lst.IndexOf(Self.TagKzList.Items[i].KurzBez) = -1 then
      begin
        model := Self.TagKzList.Items[i];
        lst.Add(model.KurzBez);
        Inc(cc);
        if cc > sgAbwLegend.ColCount - 1 then
          sgAbwLegend.ColCount := sgAbwLegend.ColCount + 1;
        sgAbwLegend.Cells[cc, 0] := AlignCenter(model.Bezeichnung,
          RgbColorToHtmlColor(model.Farbe), CalcFontColor(model.Farbe));
      end;
    end;
  end;
  cc := sgAbwLegend.ClientWidth div sgAbwLegend.ColCount;
  for i := 0 to sgAbwLegend.ColCount - 1 do
    sgAbwLegend.ColWidths[i] := cc;
end;

procedure TAbwForm.GetFeiertage;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TFeiertagList then
      Self.FeiertagList := Sender as TFeiertagList;
    Self.GetTagKz;
  end;

begin
  if Self.FeiertagList = nil then
    Self.FeiertagList := TFeiertagList.Create
  else
    Self.FeiertagList.Clear;
  Self.FeiertagList.OnPropertyChanged := Callback;
  Self.FeiertagList.GetAll(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
    Self.Year);
end;

procedure TAbwForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp := Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure TAbwForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp := Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TAbwForm.GetTagKz;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TTagKzList then
      Self.TagKzList := Sender as TTagKzList;
    Self.SgAbwInit;
  end;

begin
  if Self.TagKzList = nil then
    Self.TagKzList := TTagKzList.Create
  else
    Self.TagKzList.Clear;
  Self.TagKzList.OnPropertyChanged := Callback;
  Self.TagKzList.GetAll(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
    Self.Year);
end;

procedure TAbwForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure TAbwForm.SetFeiertagList(const Value: TFeiertagList);
begin
  FFeiertagList := Value;
end;

procedure TAbwForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  Self.btnHoliday.Visible := Self.MainConfig.MenuConfig.btnHoliday;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  Self.pnlData.Color := clWindow;
  Self.pnlAbw.Color := clWindow;
  Self.sgAbw.FixedColor := Self.MainConfig.ColorConfig.BackgroundColor;
  Self.Year := YearOf(date);
end;

procedure TAbwForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure TAbwForm.SetTagKzList(const Value: TTagKzList);
begin
  FTagKzList := Value;
end;

procedure TAbwForm.SetYear(Value: Integer);
begin
  if Value < yearMin then
    Value := yearMin;
  if Value > yearMax then
    Value := yearMax;
  FYear := Value;
  btnPrior.Enabled := Self.Year > yearMin;
  btnNext.Enabled := Self.Year < yearMax;
  sgAbw.Cells[1, 0] := AlignCenter(Bold(IntToStr(Self.Year)));
  Self.GetFeiertage;
end;

procedure TAbwForm.sgAbwClickCell(Sender: TObject; ACol, ARow: Integer);
var
  monat: TMonthModel;
  helper: Integer;
  s: string;
  feiertag: TFeiertagModel;
  tagKz: TTagKzModel;
begin
  Self.MainConfig.TimerReset;
  if (ARow > 0) and (ARow < sgAbw.RowCount - 1) then
  begin
    monat := TMonthModel.Create(ARow, Self.Year, Self.FeiertagList,
      Self.MainConfig.ColorConfig, Self.TagKzList);
    helper := monat.IndexToTag(ACol - 2);
    if helper > 0 then
    begin
      s := IntToStr(helper) + '.' + IntToStr(ARow) + '.' + IntToStr(Self.Year);
      tagKz := Self.TagKzList.GetItemByDatum(StrToDateTime(s));
      if tagKz <> nil then
      begin
        s := DateTimeToStr(tagKz.Datum) + #13#10;
        s := s + tagKz.Bezeichnung;
        MessageDLG(s, mtInformation, [mbOK]);
      end
      else
      begin
        feiertag := Self.FeiertagList.GetItemByDatum(StrToDateTime(s));
        if feiertag <> nil then
        begin
          s := DateTimeToStr(feiertag.Datum) + #13#10;
          s := s + feiertag.Bezeichnung;
          MessageDLG(s, mtInformation, [mbOK]);
        end;
      end;
    end;
    monat.Free;
  end;
end;

procedure TAbwForm.SgAbwInit;
var
  i, j: Integer;
  colWidth: Integer;
  abw: TMonthModel;
begin
  sgAbw.ColCount := 39;
  sgAbw.RowCount := 14;
  sgAbw.FixedCols := 2;
  sgAbw.FixedRows := 1;
  sgAbw.ColWidths[0] := 5;
  sgAbw.ColWidths[1] := 40;
  sgAbw.RowHeights[sgAbw.RowCount - 1] := sgAbw.DefaultRowHeight div 2;
  colWidth := Max(25, (sgAbw.ClientWidth - sgAbw.ColWidths[0] - sgAbw.ColWidths
    [1] - 32) div 37);
  for i := 2 to sgAbw.ColCount - 1 do
    sgAbw.ColWidths[i] := colWidth;
  sgAbw.Cells[1, 0] := AlignCenter(Bold(IntToStr(Self.Year)));
  for i := 2 to sgAbw.ColCount - 1 do
    sgAbw.Cells[i, 0] := AlignCenter(Bold(WeekDay(i - 2)));
  for i := 1 to sgAbw.RowCount - 2 do
    sgAbw.Cells[1, i] := AlignCenter(Bold(MonthToStr(i - 1)));
  for i := 1 to 12 do
  begin
    abw := TMonthModel.Create(i, Self.Year, Self.FeiertagList,
      Self.MainConfig.ColorConfig, Self.TagKzList);
    for j := 2 to sgAbw.ColCount - 1 do
      sgAbw.Cells[j, i] := abw.IndexToStr(j - 2);
  end;
  Self.GetAbw;
end;

procedure TAbwForm.WebFormCreate(Sender: TObject);
begin
  yearMin := YearOf(date) - 5;
  yearMax := YearOf(date) + 1;
  Self.Stamp := nil;
  Self.FakStamp := nil;
end;

procedure TAbwForm.WebFormResize(Sender: TObject);
var
  colWidth, i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Abwesenheitskalender';
    btnPrior.Top := 4;
    btnPrior.Left := 4;
    btnPrior.Width := 120;
    btnPrior.Height := 32;
    btnPrior.GlyphSize := 24;
    btnNext.Top := btnPrior.Top;
    btnNext.Left := btnPrior.Left + btnPrior.Width + 4;
    btnNext.Width := 120;
    btnNext.Height := 32;
    btnNext.GlyphSize := 24;
    btnHoliday.Top := btnNext.Top;
    btnHoliday.Left := btnNext.Left + btnNext.Width + 4;
    btnHoliday.Height := 32;
    btnHoliday.Width := 120;
    btnHoliday.GlyphSize := 24;
    pnlButton.Height := 40;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Abwesenheitskalender';
    btnPrior.Top := 8;
    btnPrior.Left := 8;
    btnPrior.Width := 160;
    btnPrior.Height := 48;
    btnPrior.GlyphSize := 32;
    btnNext.Top := btnPrior.Top;
    btnNext.Left := btnPrior.Left + btnPrior.Width + 8;
    btnNext.Width := 160;
    btnNext.Height := 48;
    btnNext.GlyphSize := 32;
    btnHoliday.Top := btnNext.Top;
    btnHoliday.Left := btnNext.Left + btnNext.Width + 8;
    btnHoliday.Height := 48;
    btnHoliday.Width := 160;
    btnHoliday.GlyphSize := 32;
    pnlButton.Height := 64;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  colWidth := Max(25, (sgAbw.ClientWidth - sgAbw.ColWidths[0] - sgAbw.ColWidths
    [1] - 32) div 37);
  for i := 2 to sgAbw.ColCount - 1 do
    sgAbw.ColWidths[i] := colWidth;
  colWidth := sgAbwLegend.ClientWidth div sgAbwLegend.ColCount;
  for i := 0 to sgAbwLegend.ColCount - 1 do
    sgAbwLegend.ColWidths[i] := colWidth;
end;

procedure TAbwForm.WebFormShow(Sender: TObject);
begin
  Self.WebFormResize(Sender);
end;

procedure TAbwForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlButton := TPanel.Create(Self);
  btnHoliday := TBitBtn.Create(Self);
  btnPrior := TBitBtn.Create(Self);
  btnNext := TBitBtn.Create(Self);
  pnlData := TPanel.Create(Self);
  sgAbw := TStringGrid.Create(Self);
  pnlAbw := TPanel.Create(Self);
  sgAbwLegend := TStringGrid.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlButton.BeforeLoadDFMValues;
  btnHoliday.BeforeLoadDFMValues;
  btnPrior.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  sgAbw.BeforeLoadDFMValues;
  pnlAbw.BeforeLoadDFMValues;
  sgAbwLegend.BeforeLoadDFMValues;
  try
    Name := 'AbwForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UAbwForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Zeitdaten';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UAbwForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlButton.SetParentComponent(Self);
    pnlButton.Name := 'pnlButton';
    pnlButton.Left := 0;
    pnlButton.Top := 92;
    pnlButton.Width := 640;
    pnlButton.Height := 64;
    pnlButton.Align := alTop;
    pnlButton.Caption := 'pnlButton';
    pnlButton.ChildOrder := 3;
    pnlButton.ShowCaption := False;
    btnHoliday.SetParentComponent(pnlButton);
    btnHoliday.Name := 'btnHoliday';
    btnHoliday.Tag := 1;
    btnHoliday.Left := 344;
    btnHoliday.Top := 8;
    btnHoliday.Width := 160;
    btnHoliday.Height := 48;
    btnHoliday.Caption := 'Urlaubsantrag';
    btnHoliday.Color := clNone;
    btnHoliday.Glyph.LoadFromFile('UAbwForm.pnlButton.btnHoliday.Glyph.png');
    btnHoliday.GlyphSize := 32;
    btnHoliday.HeightPercent := 100.000000000000000000;
    btnHoliday.WidthPercent := 100.000000000000000000;
    SetEvent(btnHoliday, Self, 'OnClick', 'btnHolidayClick');
    btnPrior.SetParentComponent(pnlButton);
    btnPrior.Name := 'btnPrior';
    btnPrior.Left := 8;
    btnPrior.Top := 8;
    btnPrior.Width := 160;
    btnPrior.Height := 48;
    btnPrior.Caption := 'Jahr zur'#252'ck';
    btnPrior.Color := clNone;
    btnPrior.Glyph.LoadFromFile('UAbwForm.pnlButton.btnPrior.Glyph.png');
    btnPrior.GlyphSize := 32;
    btnPrior.HeightPercent := 100.000000000000000000;
    btnPrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrior, Self, 'OnClick', 'btnPriorClick');
    btnNext.SetParentComponent(pnlButton);
    btnNext.Name := 'btnNext';
    btnNext.Left := 176;
    btnNext.Top := 8;
    btnNext.Width := 160;
    btnNext.Height := 48;
    btnNext.Caption := 'Jahr vor';
    btnNext.Color := clNone;
    btnNext.Glyph.LoadFromFile('UAbwForm.pnlButton.btnNext.Glyph.png');
    btnNext.GlyphSize := 32;
    btnNext.HeightPercent := 100.000000000000000000;
    btnNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnNext, Self, 'OnClick', 'btnNextClick');
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 0;
    pnlData.Top := 156;
    pnlData.Width := 640;
    pnlData.Height := 276;
    pnlData.Align := alClient;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 4;
    pnlData.ShowCaption := False;
    sgAbw.SetParentComponent(pnlData);
    sgAbw.Name := 'sgAbw';
    sgAbw.Left := 0;
    sgAbw.Top := 0;
    sgAbw.Width := 640;
    sgAbw.Height := 276;
    sgAbw.Align := alClient;
    sgAbw.ColCount := 1;
    sgAbw.FixedCols := 0;
    sgAbw.RowCount := 1;
    sgAbw.FixedRows := 0;
    sgAbw.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goFixedRowDefAlign];
    sgAbw.TabOrder := 0;
    sgAbw.RangeEdit.Max := 100.000000000000000000;
    sgAbw.RangeEdit.Step := 1.000000000000000000;
    sgAbw.SelectionTextColor := clBlack;
    sgAbw.HeightPercent := 100.000000000000000000;
    sgAbw.WidthPercent := 100.000000000000000000;
    SetEvent(sgAbw, Self, 'OnClickCell', 'sgAbwClickCell');
    pnlAbw.SetParentComponent(Self);
    pnlAbw.Name := 'pnlAbw';
    pnlAbw.Left := 0;
    pnlAbw.Top := 432;
    pnlAbw.Width := 640;
    pnlAbw.Height := 24;
    pnlAbw.Align := alBottom;
    pnlAbw.Caption := 'pnlStatus';
    pnlAbw.ChildOrder := 2;
    pnlAbw.ShowCaption := False;
    sgAbwLegend.SetParentComponent(pnlAbw);
    sgAbwLegend.Name := 'sgAbwLegend';
    sgAbwLegend.Left := 0;
    sgAbwLegend.Top := 0;
    sgAbwLegend.Width := 640;
    sgAbwLegend.Height := 24;
    sgAbwLegend.Align := alClient;
    sgAbwLegend.ColCount := 1;
    sgAbwLegend.FixedCols := 0;
    sgAbwLegend.RowCount := 1;
    sgAbwLegend.FixedRows := 0;
    sgAbwLegend.Font.Charset := ANSI_CHARSET;
    sgAbwLegend.Font.Color := clWindowText;
    sgAbwLegend.Font.Height := -12;
    sgAbwLegend.Font.Name := 'Segoe UI';
    sgAbwLegend.Font.Style := [];
    sgAbwLegend.Options := [goRangeSelect,goFixedRowDefAlign];
    sgAbwLegend.ParentFont := False;
    sgAbwLegend.ScrollBars := ssNone;
    sgAbwLegend.TabOrder := 0;
    sgAbwLegend.RangeEdit.Max := 100.000000000000000000;
    sgAbwLegend.RangeEdit.Step := 1.000000000000000000;
    sgAbwLegend.HeightPercent := 100.000000000000000000;
    sgAbwLegend.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlButton.AfterLoadDFMValues;
    btnHoliday.AfterLoadDFMValues;
    btnPrior.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    sgAbw.AfterLoadDFMValues;
    pnlAbw.AfterLoadDFMValues;
    sgAbwLegend.AfterLoadDFMValues;
  end;
end;

end.
